const data = {
  "searchField": {
    "placeholder": "Zoeken naar...",
    "personalizedPlaceholder": "Hoi {{name}}, waar ben je naar op zoek?",
    "ariaLabel": "Zoeken naar producten",
    "buttonAriaLabel": "Zoeken",
    "cancelButtonText": "Annuleren"
  }
};

export default data;